import {
  Badge,
  Box,
  Button,
  CheckboxIcon,
  Divider,
  IconButton,
  Input,
  InputGroup,
  InputRightElement,
  Stack,
  Text,
  useColorModeValue,
} from "@chakra-ui/react";
import dayjs from "dayjs";
import {
  collection,
  getDocs,
  query,
  setDoc,
  where,
  doc,
  getDoc,
} from "firebase/firestore";
import { useEffect, useState } from "react";
import { BiRadioCircleMarked, BiSearch, BiToggleLeft } from "react-icons/bi";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import Heading from "../../components/Heading";
import { useGetState } from "../../context/useGetState";
import { db } from "../../service/firebase";
import ChatProfileCard from "./ChatProfileCard";
import ExternalUserChatProfile from "./ExternalUserChatProfile11";
import { v4 as uuid } from "uuid";
import SearchUser from "./SearchUser";

function LeftSection({
  contacts,
  changeChat,
  onlineUsers,
  privateChatRecipient,
  typingUserId,
  privateContact,
  ///////////////
  setShowChatDetails,
  accountType,
  chats,
  setChats,
  ...props
}) {
  const { state } = useGetState();
  const { userInfo } = state;
  const selectedBorderColor = useColorModeValue("#DBE5ED", "#081b2e");
  const selectChatBg = useColorModeValue("#fff", "#010000");
  const inputBorderColor = useColorModeValue("#DBE5ED", "none");
  const hoverBgColor = useColorModeValue("#f2f2f2", "#010000");

  const [userSearch, setUserSearch] = useState("");
  const [userSearchResult, setUserSearchResult] = useState(null);
  const [isComponentVisible, setIsComponentVisible] = useState(true);
  const [userOnline, setUserOnline] = useState(false);

  const [selectedContact, setSelectedContact] = useState(null);
  const { state: navigationData } = useLocation();
  const { privateUserId } = useParams();

  const navigate = useNavigate();

  //to check other privateUser online
  let isOnlinePrivate = false;
  if (privateUserId) {
    isOnlinePrivate = onlineUsers?.some(
      (user) => user?.userId == privateUserId?.id
    )
      ? true
      : false;
  }

  /////////////////////////////////////
  const changeSelectedChat = (index, chat) => {
    setSelectedContact(index);
    changeChat(chat);
  };
  ////////////////////////////////////

  const loggedInUserId = userInfo;
  const setChatID = (id) => {
    if (sessionStorage.getItem("CHAT_ID")) {
      sessionStorage.removeItem("CHAT_ID");
    }
    sessionStorage.setItem("CHAT_ID", id);
  };

  const toggleComponentVisibility = () => {
    setIsComponentVisible((prevVisibility) => !prevVisibility);
  };
  return (
    <>
      {isComponentVisible && (
        <Stack flex="2" {...props}>
          <Stack alignItems={"flex-start"} mb="10px">
            <Heading>Chat</Heading>

            <Divider />
          </Stack>
          <Text color={"#7B8793"} textAlign={"left"} mb="10px !important">
            Active Chats
          </Text>
          <Stack
            h={[window.innerHeight - 280]}
            maxH={[window.innerHeight - 280]}
            overflowY="scroll"
            className="scroll-container"
            px="5px"
          >
            <InputGroup
              mb="10px !important"
              border={`1px solid ${inputBorderColor}`}
              borderRadius={"10px"}
            >
              <InputRightElement
                pointerEvents="none"
                children={
                  <BiSearch
                    style={{ marginBottom: "10px" }}
                    fontSize={".7em"}
                    color="#AFBBC6"
                  />
                }
              />
              <Input
                size={"xs"}
                placeholder="Search people"
                type="text"
                borderRadius={"10px"}
                value={userSearch}
                onChange={(e) => setUserSearch(e.target.value)}
              />
            </InputGroup>
            <Stack spacing={"10px"}>
              {userSearchResult ? (
                <SearchUser
                  props={props}
                  setChatID={setChatID}
                  hoverBgColor={hoverBgColor}
                  selectedBorderColor={selectedBorderColor}
                  selectChatBg={selectChatBg}
                  chats={chats}
                  search={userSearch}
                  searchResult={userSearchResult}
                />
              ) : (
                contacts &&
                contacts.map((chat, index) => {
                  return (
                    <>
                      <Box
                        key={chat?.id}
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "center",
                        }}
                        borderRadius={"7px"}
                        p="7px"
                        cursor={"pointer"}
                        border={
                          privateUserId !== undefined ||
                          index === selectedContact
                            ? `1px solid ${selectedBorderColor}`
                            : ""
                        }
                        bg={
                          privateUserId !== undefined ||
                          index === selectedContact
                            ? selectChatBg
                            : ""
                        }
                        onClick={() => changeSelectedChat(index, chat)}
                        _hover={{ bg: hoverBgColor }}
                      >
                        <ExternalUserChatProfile
                          selectedChat={props?.selectedChat}
                          chat={chat}
                          onlineUsers={onlineUsers}
                        />
                        {!privateUserId && (
                          <Badge
                            style={{
                              color: "white",
                              border: "1px solid green",
                              borderRadius: "50%",
                              backgroundColor: "green",
                            }}
                          >
                            <Text style={{ fontWeight: "0.5em" }}>
                              {chat?.unread_messages?.length}
                            </Text>
                          </Badge>
                        )}
                      </Box>
                    </>
                  );
                })
              )}
            </Stack>
          </Stack>
        </Stack>
      )}
    </>
  );
}

export default LeftSection;
